// extracted by mini-css-extract-plugin
export default {"root":"PageTitle_root__xj90n"};